import type { ExchangeSourceOption } from '../models/exchangeSource';

/** Matches server `DOLAR_OFICIAL_SOURCE_NAME` (signup / org defaults). */
export const DOLAR_OFICIAL_SOURCE_NAME = 'Dolar Oficial';

const normalizeSourceName = (name?: string): string => (name || '').trim();

export const compareExchangeSourcesByRecency = (
  a: Pick<ExchangeSourceOption, 'lastFetchedAt'>,
  b: Pick<ExchangeSourceOption, 'lastFetchedAt'>
): number => {
  const at = a.lastFetchedAt ? new Date(a.lastFetchedAt).getTime() : 0;
  const bt = b.lastFetchedAt ? new Date(b.lastFetchedAt).getTime() : 0;
  return bt - at;
};

/** Prefer Dolar Oficial; otherwise the most recently fetched source. */
export const pickDefaultExchangeSource = (
  sources: ExchangeSourceOption[]
): ExchangeSourceOption | null => {
  if (sources.length === 0) return null;
  const dolarOficial = sources.find(
    s => normalizeSourceName(s.name) === DOLAR_OFICIAL_SOURCE_NAME
  );
  if (dolarOficial) return dolarOficial;
  return [...sources].sort(compareExchangeSourcesByRecency)[0] ?? null;
};

/** Dolar Oficial first, then others by recency (signup source list). */
export const sortExchangeSourcesForDisplay = (
  sources: ExchangeSourceOption[]
): ExchangeSourceOption[] => {
  const sorted = [...sources].sort(compareExchangeSourcesByRecency);
  const oficialIndex = sorted.findIndex(
    s => normalizeSourceName(s.name) === DOLAR_OFICIAL_SOURCE_NAME
  );
  if (oficialIndex <= 0) return sorted;
  const [oficial] = sorted.splice(oficialIndex, 1);
  return [oficial, ...sorted];
};

export const isDolarOficialExchangeSource = (
  source: Pick<ExchangeSourceOption, 'name'>
): boolean =>
  normalizeSourceName(source.name) === DOLAR_OFICIAL_SOURCE_NAME;
